var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg401(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path--inject-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M274.92,330.5V311H216.24v19.5A27.88,27.88,0,0,1,210,348l-2.57,3.18h76.28L281.15,348A27.83,27.83,0,0,1,274.92,330.5Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-4"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "344.1 361.12 151.32 361.12 166.54 346.43 328.88 346.43 344.1 361.12",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.68,352.1c0,3-34.91,5.47-78,5.47s-78-2.45-78-5.47,34.91-5.48,78-5.48S322.68,349.07,322.68,352.1Z",
    style: {
      fill: "#DC143C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.68,352.1c0,3-34.91,5.47-78,5.47s-78-2.45-78-5.47,34.91-5.48,78-5.48S322.68,349.07,322.68,352.1Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 151.32,
    y: 361.12,
    width: 192.78,
    height: 13.61,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "357.74 389.41 137.68 389.41 151.32 374.73 344.1 374.73 357.74 389.41",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 137.72,
    y: 389.41,
    width: 219.98,
    height: 14.32,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "245.58 215.93 245.58 124.4 280.41 124.4 280.41 85.89",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 259.19,
    y1: 123.97,
    x2: 259.19,
    y2: 85.89,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "248.18 230.52 408.54 230.52 408.54 207.72 439.19 207.72",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "240.32 229.73 87.83 229.73 87.83 205.37 54.82 205.37",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "214.38 61.52 214.38 96.11 194.73 96.11 194.73 118.11 219.1 118.11 219.1 192",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "322.07 163.7 322.07 114.18 335.43 114.18 335.43 92.96 346.44 92.96",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "160.15 158.99 160.15 121.26 149.14 110.25 149.14 82.74",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "351.94 181 379.45 181 379.45 162.92 397.53 162.92 397.53 152.7 413.25 152.7",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "132.63 187.29 103.55 187.29 103.55 164.49 62.68 164.49",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "159.36 310.69 159.36 331.13 146 331.13 146 353.93 107.48 353.93",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "306.35 313.84 306.35 335.06 337 335.06 337 326.42 345.65 326.42 345.65 344.49 372.38 344.49",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.65,85.89a2.24,2.24,0,1,1-2.24-2.25A2.24,2.24,0,0,1,282.65,85.89Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.51,85.89a2.24,2.24,0,1,1-2.24-2.25A2.24,2.24,0,0,1,261.51,85.89Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.64,60.87a2.25,2.25,0,1,1-2.24-2.25A2.24,2.24,0,0,1,216.64,60.87Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.4,81.61a2.24,2.24,0,1,1-2.24-2.25A2.24,2.24,0,0,1,151.4,81.61Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.92,164.49a2.25,2.25,0,1,1-2.24-2.24A2.24,2.24,0,0,1,64.92,164.49Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.13,205.3a2.25,2.25,0,1,1-2.25-2.25A2.25,2.25,0,0,1,57.13,205.3Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.92,353.5a2.25,2.25,0,1,1-2.24-2.25A2.24,2.24,0,0,1,109.92,353.5Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.76,344.05a2.25,2.25,0,1,1-2.25-2.24A2.24,2.24,0,0,1,375.76,344.05Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M442.57,207.28a2.24,2.24,0,1,1-2.24-2.24A2.24,2.24,0,0,1,442.57,207.28Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.55,152.22a2.24,2.24,0,1,1-2.24-2.24A2.24,2.24,0,0,1,416.55,152.22Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.13,92.9a2.24,2.24,0,1,1-2.24-2.24A2.24,2.24,0,0,1,350.13,92.9Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.92,330.5V311H216.24v19.5A27.88,27.88,0,0,1,210,348l-2.57,3.18h76.28L281.15,348A27.83,27.83,0,0,1,274.92,330.5Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path--inject-4)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M212.64,344.16h65.88a27.77,27.77,0,0,1-3.6-13.66V311H216.24v19.5A27.77,27.77,0,0,1,212.64,344.16Z",
    style: {
      fill: "#DC143C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.64,344.16h65.88a27.77,27.77,0,0,1-3.6-13.66V311H216.24v19.5A27.77,27.77,0,0,1,212.64,344.16Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.64,323.6h65.88a27.77,27.77,0,0,1-3.6-13.66v-19.5H216.24v19.5A27.77,27.77,0,0,1,212.64,323.6Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M274.92,330.5V311H216.24v19.5A27.88,27.88,0,0,1,210,348l-2.57,3.18h76.28L281.15,348A27.83,27.83,0,0,1,274.92,330.5Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 127.67,
    y: 143.99,
    width: 235.82,
    height: 173.15,
    rx: 8.48,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.67,290.23H363.49a0,0,0,0,1,0,0v18.43a8.48,8.48,0,0,1-8.48,8.48H136.15a8.48,8.48,0,0,1-8.48-8.48V290.23a0,0,0,0,1,0,0Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 139.53,
    y: 154.77,
    width: 212.09,
    height: 122.33,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.93,308a4.35,4.35,0,1,0-4.35,4.26A4.31,4.31,0,0,0,249.93,308Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 207.44,
    y: 351.21,
    width: 76.29,
    height: 3.48,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.9,148.42c-10.66,10-38,20-69.81,41.29,0,0,2,72,69.81,111.31Z",
    style: {
      fill: "#DC143C",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.9,148.42c10.67,10,38,20,69.82,41.29,0,0-2,72-69.82,111.31Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.9,154.55C233,163.49,210.71,172,181.21,191.74c0,0,1.85,66.7,64.69,103.16,62.85-36.46,64.7-103.16,64.7-103.16C281.1,172,258.88,163.49,245.9,154.55Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.6,191.74c-29.5-19.73-51.72-28.25-64.7-37.19V294.9C308.75,258.44,310.6,191.74,310.6,191.74Z",
    style: {
      fill: "#DC143C",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 126.94,
    y: 227.05,
    width: 237.28,
    height: 15.36,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.61,229.49a1.59,1.59,0,1,1-1.59-1.56A1.57,1.57,0,0,1,131.61,229.49Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.11,230.35a1.27,1.27,0,0,0,2.19-.86,1.22,1.22,0,0,0-.32-.81A18.37,18.37,0,0,0,129.11,230.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.85,229.49a1.6,1.6,0,1,1-1.6-1.56A1.58,1.58,0,0,1,137.85,229.49Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.34,230.35a1.27,1.27,0,0,0,2.19-.86,1.22,1.22,0,0,0-.32-.81A19.51,19.51,0,0,0,135.34,230.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.08,229.49a1.6,1.6,0,0,1-3.19,0,1.6,1.6,0,0,1,3.19,0Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.57,230.35a1.28,1.28,0,0,0,.92.39,1.26,1.26,0,0,0,1.27-1.25,1.18,1.18,0,0,0-.32-.81A19.51,19.51,0,0,0,141.57,230.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.31,229.49a1.59,1.59,0,1,1-1.59-1.56A1.57,1.57,0,0,1,150.31,229.49Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.8,230.35a1.28,1.28,0,0,0,2.2-.86,1.22,1.22,0,0,0-.32-.81A18.53,18.53,0,0,0,147.8,230.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.54,229.49a1.59,1.59,0,1,1-1.59-1.56A1.57,1.57,0,0,1,156.54,229.49Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154,230.35a1.29,1.29,0,0,0,.92.39,1.26,1.26,0,0,0,1.28-1.25,1.22,1.22,0,0,0-.32-.81A19.68,19.68,0,0,0,154,230.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.77,229.49a1.59,1.59,0,1,1-1.59-1.56A1.57,1.57,0,0,1,162.77,229.49Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.27,230.35a1.27,1.27,0,0,0,2.19-.86,1.22,1.22,0,0,0-.32-.81A18.37,18.37,0,0,0,160.27,230.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169,229.49a1.6,1.6,0,1,1-1.6-1.56A1.58,1.58,0,0,1,169,229.49Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.5,230.35a1.27,1.27,0,0,0,2.19-.86,1.22,1.22,0,0,0-.32-.81A19.51,19.51,0,0,0,166.5,230.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.24,229.49a1.59,1.59,0,1,1-1.59-1.56A1.57,1.57,0,0,1,175.24,229.49Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.73,230.35a1.28,1.28,0,0,0,.92.39,1.26,1.26,0,0,0,1.27-1.25,1.18,1.18,0,0,0-.32-.81A19.51,19.51,0,0,0,172.73,230.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.47,229.49a1.59,1.59,0,1,1-1.59-1.56A1.57,1.57,0,0,1,181.47,229.49Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179,230.35a1.28,1.28,0,0,0,2.2-.86,1.22,1.22,0,0,0-.32-.81A19.68,19.68,0,0,0,179,230.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.7,229.49a1.59,1.59,0,1,1-1.59-1.56A1.57,1.57,0,0,1,187.7,229.49Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.19,230.35a1.29,1.29,0,0,0,.92.39,1.26,1.26,0,0,0,1.28-1.25,1.22,1.22,0,0,0-.32-.81A19.68,19.68,0,0,0,185.19,230.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.93,229.49a1.59,1.59,0,1,1-1.59-1.56A1.57,1.57,0,0,1,193.93,229.49Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.43,230.35a1.27,1.27,0,0,0,2.19-.86,1.22,1.22,0,0,0-.32-.81A19.51,19.51,0,0,0,191.43,230.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.17,229.49a1.6,1.6,0,1,1-1.59-1.56A1.57,1.57,0,0,1,200.17,229.49Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.66,230.35a1.27,1.27,0,0,0,2.19-.86,1.18,1.18,0,0,0-.32-.81A19.51,19.51,0,0,0,197.66,230.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.4,229.49a1.59,1.59,0,1,1-1.59-1.56A1.57,1.57,0,0,1,206.4,229.49Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.89,230.35a1.28,1.28,0,0,0,2.2-.86,1.22,1.22,0,0,0-.32-.81A18.53,18.53,0,0,0,203.89,230.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.63,229.49a1.59,1.59,0,1,1-1.59-1.56A1.57,1.57,0,0,1,212.63,229.49Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.12,230.35a1.29,1.29,0,0,0,.92.39,1.26,1.26,0,0,0,1.28-1.25,1.22,1.22,0,0,0-.32-.81A19.68,19.68,0,0,0,210.12,230.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.61,239.4a1.59,1.59,0,1,1-1.59-1.55A1.57,1.57,0,0,1,131.61,239.4Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.11,240.27a1.25,1.25,0,0,0,.91.39,1.27,1.27,0,0,0,1.28-1.26,1.22,1.22,0,0,0-.32-.8A18.37,18.37,0,0,0,129.11,240.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.85,239.4a1.6,1.6,0,1,1-1.6-1.55A1.58,1.58,0,0,1,137.85,239.4Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.34,240.27a1.25,1.25,0,0,0,.91.39,1.27,1.27,0,0,0,1.28-1.26,1.22,1.22,0,0,0-.32-.8A19.51,19.51,0,0,0,135.34,240.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.08,239.4a1.6,1.6,0,1,1-1.59-1.55A1.57,1.57,0,0,1,144.08,239.4Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.57,240.27a1.27,1.27,0,0,0,2.19-.87,1.17,1.17,0,0,0-.32-.8A19.51,19.51,0,0,0,141.57,240.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.31,239.4a1.59,1.59,0,1,1-1.59-1.55A1.57,1.57,0,0,1,150.31,239.4Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.8,240.27a1.28,1.28,0,0,0,2.2-.87,1.22,1.22,0,0,0-.32-.8A18.53,18.53,0,0,0,147.8,240.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.54,239.4a1.59,1.59,0,1,1-1.59-1.55A1.57,1.57,0,0,1,156.54,239.4Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154,240.27a1.29,1.29,0,0,0,.92.39,1.27,1.27,0,0,0,1.28-1.26,1.22,1.22,0,0,0-.32-.8A19.68,19.68,0,0,0,154,240.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.77,239.4a1.59,1.59,0,1,1-1.59-1.55A1.57,1.57,0,0,1,162.77,239.4Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.27,240.27a1.25,1.25,0,0,0,.91.39,1.27,1.27,0,0,0,1.28-1.26,1.22,1.22,0,0,0-.32-.8A18.37,18.37,0,0,0,160.27,240.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169,239.4a1.6,1.6,0,1,1-1.6-1.55A1.58,1.58,0,0,1,169,239.4Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.5,240.27a1.25,1.25,0,0,0,.91.39,1.27,1.27,0,0,0,1.28-1.26,1.22,1.22,0,0,0-.32-.8A19.51,19.51,0,0,0,166.5,240.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.24,239.4a1.59,1.59,0,1,1-1.59-1.55A1.57,1.57,0,0,1,175.24,239.4Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.73,240.27a1.27,1.27,0,0,0,2.19-.87,1.17,1.17,0,0,0-.32-.8A19.51,19.51,0,0,0,172.73,240.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M181.47,239.4a1.59,1.59,0,1,1-1.59-1.55A1.57,1.57,0,0,1,181.47,239.4Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179,240.27a1.28,1.28,0,0,0,2.2-.87,1.22,1.22,0,0,0-.32-.8A19.68,19.68,0,0,0,179,240.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.7,239.4a1.59,1.59,0,1,1-1.59-1.55A1.57,1.57,0,0,1,187.7,239.4Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.19,240.27a1.29,1.29,0,0,0,.92.39,1.27,1.27,0,0,0,1.28-1.26,1.22,1.22,0,0,0-.32-.8A19.68,19.68,0,0,0,185.19,240.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.93,239.4a1.59,1.59,0,1,1-1.59-1.55A1.57,1.57,0,0,1,193.93,239.4Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.43,240.27a1.25,1.25,0,0,0,.91.39,1.27,1.27,0,0,0,1.28-1.26,1.22,1.22,0,0,0-.32-.8A19.51,19.51,0,0,0,191.43,240.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.17,239.4a1.6,1.6,0,1,1-1.59-1.55A1.57,1.57,0,0,1,200.17,239.4Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.66,240.27a1.27,1.27,0,0,0,2.19-.87,1.17,1.17,0,0,0-.32-.8A19.51,19.51,0,0,0,197.66,240.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.4,239.4a1.59,1.59,0,1,1-1.59-1.55A1.57,1.57,0,0,1,206.4,239.4Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.89,240.27a1.28,1.28,0,0,0,2.2-.87,1.22,1.22,0,0,0-.32-.8A18.53,18.53,0,0,0,203.89,240.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.63,239.4a1.59,1.59,0,1,1-1.59-1.55A1.57,1.57,0,0,1,212.63,239.4Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.12,240.27a1.29,1.29,0,0,0,.92.39,1.27,1.27,0,0,0,1.28-1.26,1.22,1.22,0,0,0-.32-.8A19.68,19.68,0,0,0,210.12,240.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.68,229.49a1.59,1.59,0,1,1-1.59-1.56A1.57,1.57,0,0,1,281.68,229.49Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.18,230.35a1.27,1.27,0,0,0,2.19-.86,1.22,1.22,0,0,0-.32-.81A19.51,19.51,0,0,0,279.18,230.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.92,229.49a1.6,1.6,0,1,1-1.59-1.56A1.57,1.57,0,0,1,287.92,229.49Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.41,230.35a1.27,1.27,0,0,0,2.19-.86,1.18,1.18,0,0,0-.32-.81A19.51,19.51,0,0,0,285.41,230.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.15,229.49a1.59,1.59,0,1,1-1.59-1.56A1.57,1.57,0,0,1,294.15,229.49Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.64,230.35a1.28,1.28,0,0,0,2.2-.86,1.22,1.22,0,0,0-.32-.81A18.53,18.53,0,0,0,291.64,230.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.38,229.49a1.59,1.59,0,1,1-1.59-1.56A1.57,1.57,0,0,1,300.38,229.49Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.87,230.35a1.29,1.29,0,0,0,.92.39,1.26,1.26,0,0,0,1.28-1.25,1.22,1.22,0,0,0-.32-.81A19.68,19.68,0,0,0,297.87,230.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.61,229.49a1.59,1.59,0,1,1-1.59-1.56A1.57,1.57,0,0,1,306.61,229.49Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.11,230.35a1.27,1.27,0,0,0,2.19-.86,1.22,1.22,0,0,0-.32-.81A18.37,18.37,0,0,0,304.11,230.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.85,229.49a1.6,1.6,0,1,1-1.6-1.56A1.58,1.58,0,0,1,312.85,229.49Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.34,230.35a1.27,1.27,0,0,0,2.19-.86,1.22,1.22,0,0,0-.32-.81A19.51,19.51,0,0,0,310.34,230.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.08,229.49a1.6,1.6,0,1,1-1.59-1.56A1.57,1.57,0,0,1,319.08,229.49Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.57,230.35a1.27,1.27,0,0,0,2.19-.86,1.18,1.18,0,0,0-.32-.81A19.51,19.51,0,0,0,316.57,230.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.31,229.49a1.59,1.59,0,1,1-1.59-1.56A1.57,1.57,0,0,1,325.31,229.49Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.8,230.35a1.28,1.28,0,0,0,2.2-.86,1.22,1.22,0,0,0-.32-.81A18.53,18.53,0,0,0,322.8,230.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.54,229.49a1.59,1.59,0,1,1-1.59-1.56A1.57,1.57,0,0,1,331.54,229.49Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329,230.35a1.29,1.29,0,0,0,.92.39,1.26,1.26,0,0,0,1.28-1.25,1.22,1.22,0,0,0-.32-.81A19.68,19.68,0,0,0,329,230.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.77,229.49a1.59,1.59,0,1,1-1.59-1.56A1.57,1.57,0,0,1,337.77,229.49Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.27,230.35a1.27,1.27,0,0,0,2.19-.86,1.22,1.22,0,0,0-.32-.81A18.37,18.37,0,0,0,335.27,230.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344,229.49a1.6,1.6,0,1,1-1.6-1.56A1.58,1.58,0,0,1,344,229.49Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.5,230.35a1.27,1.27,0,0,0,2.19-.86,1.22,1.22,0,0,0-.32-.81A19.51,19.51,0,0,0,341.5,230.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.24,229.49a1.59,1.59,0,1,1-1.59-1.56A1.57,1.57,0,0,1,350.24,229.49Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.73,230.35a1.28,1.28,0,0,0,.92.39,1.26,1.26,0,0,0,1.27-1.25,1.18,1.18,0,0,0-.32-.81A19.51,19.51,0,0,0,347.73,230.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.47,229.49a1.59,1.59,0,1,1-1.59-1.56A1.57,1.57,0,0,1,356.47,229.49Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354,230.35a1.28,1.28,0,0,0,2.2-.86,1.22,1.22,0,0,0-.32-.81A19.68,19.68,0,0,0,354,230.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.7,229.49a1.59,1.59,0,1,1-1.59-1.56A1.57,1.57,0,0,1,362.7,229.49Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.19,230.35a1.29,1.29,0,0,0,.92.39,1.26,1.26,0,0,0,1.28-1.25,1.22,1.22,0,0,0-.32-.81A19.68,19.68,0,0,0,360.19,230.35Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.68,239.4a1.59,1.59,0,1,1-1.59-1.55A1.57,1.57,0,0,1,281.68,239.4Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.18,240.27a1.25,1.25,0,0,0,.91.39,1.27,1.27,0,0,0,1.28-1.26,1.22,1.22,0,0,0-.32-.8A19.51,19.51,0,0,0,279.18,240.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.92,239.4a1.6,1.6,0,1,1-1.59-1.55A1.57,1.57,0,0,1,287.92,239.4Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.41,240.27a1.27,1.27,0,0,0,2.19-.87,1.17,1.17,0,0,0-.32-.8A19.51,19.51,0,0,0,285.41,240.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.15,239.4a1.59,1.59,0,1,1-1.59-1.55A1.57,1.57,0,0,1,294.15,239.4Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.64,240.27a1.28,1.28,0,0,0,2.2-.87,1.22,1.22,0,0,0-.32-.8A18.53,18.53,0,0,0,291.64,240.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.38,239.4a1.59,1.59,0,1,1-1.59-1.55A1.57,1.57,0,0,1,300.38,239.4Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.87,240.27a1.29,1.29,0,0,0,.92.39,1.27,1.27,0,0,0,1.28-1.26,1.22,1.22,0,0,0-.32-.8A19.68,19.68,0,0,0,297.87,240.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.61,239.4a1.59,1.59,0,1,1-1.59-1.55A1.57,1.57,0,0,1,306.61,239.4Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.11,240.27a1.25,1.25,0,0,0,.91.39,1.27,1.27,0,0,0,1.28-1.26,1.22,1.22,0,0,0-.32-.8A18.37,18.37,0,0,0,304.11,240.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.85,239.4a1.6,1.6,0,1,1-1.6-1.55A1.58,1.58,0,0,1,312.85,239.4Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.34,240.27a1.25,1.25,0,0,0,.91.39,1.27,1.27,0,0,0,1.28-1.26,1.22,1.22,0,0,0-.32-.8A19.51,19.51,0,0,0,310.34,240.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M319.08,239.4a1.6,1.6,0,1,1-1.59-1.55A1.57,1.57,0,0,1,319.08,239.4Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.57,240.27a1.27,1.27,0,0,0,2.19-.87,1.17,1.17,0,0,0-.32-.8A19.51,19.51,0,0,0,316.57,240.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.31,239.4a1.59,1.59,0,1,1-1.59-1.55A1.57,1.57,0,0,1,325.31,239.4Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.8,240.27a1.28,1.28,0,0,0,2.2-.87,1.22,1.22,0,0,0-.32-.8A18.53,18.53,0,0,0,322.8,240.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331.54,239.4a1.59,1.59,0,1,1-1.59-1.55A1.57,1.57,0,0,1,331.54,239.4Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329,240.27a1.29,1.29,0,0,0,.92.39,1.27,1.27,0,0,0,1.28-1.26,1.22,1.22,0,0,0-.32-.8A19.68,19.68,0,0,0,329,240.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.77,239.4a1.59,1.59,0,1,1-1.59-1.55A1.57,1.57,0,0,1,337.77,239.4Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.27,240.27a1.25,1.25,0,0,0,.91.39,1.27,1.27,0,0,0,1.28-1.26,1.22,1.22,0,0,0-.32-.8A18.37,18.37,0,0,0,335.27,240.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344,239.4a1.6,1.6,0,1,1-1.6-1.55A1.58,1.58,0,0,1,344,239.4Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M341.5,240.27a1.25,1.25,0,0,0,.91.39,1.27,1.27,0,0,0,1.28-1.26,1.22,1.22,0,0,0-.32-.8A19.51,19.51,0,0,0,341.5,240.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.24,239.4a1.59,1.59,0,1,1-1.59-1.55A1.57,1.57,0,0,1,350.24,239.4Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.73,240.27a1.27,1.27,0,0,0,2.19-.87,1.17,1.17,0,0,0-.32-.8A19.51,19.51,0,0,0,347.73,240.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.47,239.4a1.59,1.59,0,1,1-1.59-1.55A1.57,1.57,0,0,1,356.47,239.4Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354,240.27a1.28,1.28,0,0,0,2.2-.87,1.22,1.22,0,0,0-.32-.8A19.68,19.68,0,0,0,354,240.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.7,239.4a1.59,1.59,0,1,1-1.59-1.55A1.57,1.57,0,0,1,362.7,239.4Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.19,240.27a1.29,1.29,0,0,0,.92.39,1.27,1.27,0,0,0,1.28-1.26,1.22,1.22,0,0,0-.32-.8A19.68,19.68,0,0,0,360.19,240.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.41,221.8H222.2a4,4,0,0,1-4-3.92V195.64c0-15.17,12.61-27.52,28.11-27.52s28.12,12.35,28.12,27.52v22.24A4,4,0,0,1,270.41,221.8ZM226.2,214h40.2V195.64a20.1,20.1,0,0,0-40.2,0Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 215.21,
    y: 211.08,
    width: 61.38,
    height: 50.78,
    style: {
      fill: "#DC143C",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.29,232.17a6.69,6.69,0,0,0-13.37,0,6.53,6.53,0,0,0,3.51,5.76l-1.12,11.53h8.59l-1.12-11.53A6.53,6.53,0,0,0,252.29,232.17Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-4"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 384.5,
    cy: 426.5,
    rx: 47.5,
    ry: 10.5,
    style: {
      fill: "#DC143C"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 384.5,
    cy: 426.5,
    rx: 47.5,
    ry: 10.5,
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.66,415.76s-11.52,6.48-11.52,9.6,7.11,1.2,11.76-1,8.34-3.84,8.34-8.16S359.66,415.76,359.66,415.76Z",
    style: {
      fill: "#DC143C",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.81,415.76s11.52,6.48,11.52,9.6-7.11,1.2-11.76-1-8.34-3.84-8.34-8.16S414.81,415.76,414.81,415.76Z",
    style: {
      fill: "#DC143C",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.32,309.69,359.41,417a6.52,6.52,0,0,0,4.91,1.44,6.41,6.41,0,0,0,3.92-2.16l16.67-87.59h3.43L406,417.92a8.12,8.12,0,0,0,3.43,1c1.71,0,4.41-2.16,4.41-2.16l-5.64-107Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "381.48 244.66 359.17 253.77 365.05 305.61 407.7 305.61 415.55 251.85 391.28 244.18 381.48 244.66",
    style: {
      fill: "#DC143C",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "383.93 252.09 386.62 256.41 382.21 293.61 387.6 301.53 392.26 292.89 388.58 255.93 391.77 250.9 387.11 248.86 383.93 252.09",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "387.11 248.86 383.53 254.99 377.15 246.49 380.72 242.24 387.11 248.86",
    style: {
      fill: "#DC143C",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "387.11 248.86 391.45 255.61 396.68 245.99 393.62 242.11 387.11 248.86",
    style: {
      fill: "#DC143C",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "378.45 263.37 363.42 263.37 363.42 268.49 370.94 271.37 378.45 268.17 378.45 263.37",
    style: {
      fill: "#DC143C",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "408.52 263.37 393.49 263.37 393.49 268.49 401 271.37 408.52 268.17 408.52 263.37",
    style: {
      fill: "#DC143C",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 364.32,
    y: 304.65,
    width: 43.88,
    height: 5.04,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.58,308.73l-7.6,3.12a24.54,24.54,0,0,0,.49,6.48c.74,2.88,1.72,9.12,2.45,10.32s4.42,3.6,4.91,2.88,2.94-21.84,2.94-21.84Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "380.72 233.49 380.72 242.24 387.11 248.86 393.62 242.11 393.62 233.36 380.72 233.49",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.26,225.37s-1.15-2.63-1.92-1,.13,4.12,1.28,5.12a4.11,4.11,0,0,0,2.93.75l-.64-3.75Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.06,225.37s1.15-2.63,1.92-1-.13,4.12-1.28,5.12a4.13,4.13,0,0,1-2.94.75l.64-3.75Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.43,208s-5.37,2.25-5.37,6,.77,8,2.05,9.63,2.29,2.75,2.29,2.75l.26-5.38,3.7-6.37s6.13,3.87,9.19,3.87a31.6,31.6,0,0,0,5.11-.37l1.15,6.37,1.66-4.62v-4.25s3.06-2.88,2.42-4.75-11-7.75-17.36-6.25S378.43,208,378.43,208Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.87,220.62s1.53,9.37,2.81,11.87a34.74,34.74,0,0,0,6.13,7.5c.89.62,4.21.12,5.49.12s5-7.5,5.61-8.87,1-13.12,1-13.12L395.79,216s-5.49,1.38-9.83-.37a15,15,0,0,1-6.13-4.13s-.38,4.25-1.92,6.75S375.87,220.62,375.87,220.62Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.7,221.62a11,11,0,0,0-5-1.25,9.41,9.41,0,0,0-4.34.87s0,4.25,1.41,5.88,5.49,1.12,6.64-.25S385.7,221.62,385.7,221.62Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M387.49,221.62a11,11,0,0,1,5-1.25,9.41,9.41,0,0,1,4.34.87s0,4.25-1.41,5.88-5.49,1.12-6.63-.25S387.49,221.62,387.49,221.62Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 385.7,
    y1: 221.62,
    x2: 387.49,
    y2: 221.62,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.41,300.81l8.09-.24,6.13,5.52a3,3,0,0,1-.73,1.92c-.74.72-2.7.24-2.7.24s-1.47,3.6-4.17,3.6-10-5-10-5Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "359.17 253.77 331.96 289.53 355.98 306.81 359.41 300.81 352.06 286.65 362.11 277.53 359.17 253.77",
    style: {
      fill: "#DC143C",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 357.45,
    y1: 296.73,
    x2: 353.29,
    y2: 304.17,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 352.06,
    y1: 286.65,
    x2: 348.87,
    y2: 278.49,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.55,300.81l-8.09-.24-6.13,5.52a3,3,0,0,0,.74,1.92c.73.72,2.69.24,2.69.24s1.47,3.6,4.17,3.6,10.05-5,10.05-5Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "415.55 251.85 443 289.53 418.98 306.81 415.55 300.81 422.9 286.65 411.38 277.29 415.55 251.85",
    style: {
      fill: "#DC143C",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 417.51,
    y1: 296.73,
    x2: 421.67,
    y2: 304.17,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 422.9,
    y1: 286.65,
    x2: 426.09,
    y2: 278.49,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-4"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 106.5,
    cy: 426.5,
    rx: 47.5,
    ry: 10.5,
    style: {
      fill: "#DC143C"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 106.5,
    cy: 426.5,
    rx: 47.5,
    ry: 10.5,
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.82,415.76s-11.52,6.48-11.52,9.6,7.11,1.2,11.77-1,8.33-3.84,8.33-8.16S81.82,415.76,81.82,415.76Z",
    style: {
      fill: "#DC143C",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137,415.76s11.52,6.48,11.52,9.6-7.1,1.2-11.76-1-8.34-3.84-8.34-8.16S137,415.76,137,415.76Z",
    style: {
      fill: "#DC143C",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.48,309.69,81.58,417a6.49,6.49,0,0,0,4.9,1.44,6.41,6.41,0,0,0,3.92-2.16l16.67-87.59h3.43l17.65,89.27a8.12,8.12,0,0,0,3.43,1c1.72,0,4.41-2.16,4.41-2.16l-5.64-107Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "103.64 244.66 81.33 253.77 87.21 305.61 129.87 305.61 137.71 251.85 113.44 244.18 103.64 244.66",
    style: {
      fill: "#DC143C",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86.48,
    y: 304.65,
    width: 43.88,
    height: 5.04,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.74,308.73l-7.6,3.12a24.54,24.54,0,0,0,.49,6.48c.74,2.88,1.72,9.12,2.46,10.32s4.41,3.6,4.9,2.88,2.94-21.84,2.94-21.84Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "102.89 233.49 102.89 242.24 109.27 248.86 115.78 242.11 115.78 233.36 102.89 233.49",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.42,225.37s-1.15-2.63-1.92-1,.13,4.12,1.28,5.12a4.13,4.13,0,0,0,2.94.75l-.64-3.75Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.22,225.37s1.15-2.63,1.92-1-.13,4.12-1.28,5.12a4.11,4.11,0,0,1-2.93.75l.63-3.75Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.59,208s-5.36,2.25-5.36,6,.76,8,2,9.63,2.3,2.75,2.3,2.75l.25-5.38,3.7-6.37s6.13,3.87,9.19,3.87a31.6,31.6,0,0,0,5.11-.37l1.15,6.37,1.66-4.62v-4.25s3.06-2.88,2.42-4.75-11-7.75-17.36-6.25S100.59,208,100.59,208Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98,220.62s1.54,9.37,2.81,11.87A35,35,0,0,0,107,240c.89.62,4.21.12,5.49.12s5-7.5,5.62-8.87,1-13.12,1-13.12L118,216s-5.49,1.38-9.83-.37a15,15,0,0,1-6.13-4.13s-.38,4.25-1.91,6.75S98,220.62,98,220.62Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.86,221.62a11,11,0,0,0-5-1.25,9.41,9.41,0,0,0-4.34.87s0,4.25,1.4,5.88,5.49,1.12,6.64-.25S107.86,221.62,107.86,221.62Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.65,221.62a11,11,0,0,1,5-1.25,9.41,9.41,0,0,1,4.34.87s0,4.25-1.41,5.88-5.48,1.12-6.63-.25S109.65,221.62,109.65,221.62Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 107.86,
    y1: 221.62,
    x2: 109.65,
    y2: 221.62,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "106.09 252.09 108.78 256.41 104.37 293.61 109.77 301.53 114.42 292.89 110.75 255.93 113.93 250.9 109.27 248.86 106.09 252.09",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "109.27 248.86 105.69 254.99 99.31 246.49 102.89 242.24 109.27 248.86",
    style: {
      fill: "#DC143C",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "109.27 248.86 113.61 255.61 118.84 245.99 115.78 242.11 109.27 248.86",
    style: {
      fill: "#DC143C",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "81.33 253.77 54.12 289.53 78.14 306.81 81.58 300.81 74.22 286.65 84.27 277.53 81.33 253.77",
    style: {
      fill: "#DC143C",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.58,300.81l8.08-.24,6.13,5.52a3,3,0,0,1-.73,1.92c-.74.72-2.7.24-2.7.24s-1.47,3.6-4.17,3.6-10-5-10-5Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 79.62,
    y1: 296.73,
    x2: 75.45,
    y2: 304.17,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 74.22,
    y1: 286.65,
    x2: 71.04,
    y2: 278.49,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "137.71 251.85 165.16 289.53 141.14 306.81 137.71 300.81 145.06 286.65 133.54 277.29 137.71 251.85",
    style: {
      fill: "#DC143C",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.71,300.81l-8.09-.24-6.13,5.52a3,3,0,0,0,.74,1.92c.73.72,2.69.24,2.69.24s1.47,3.6,4.17,3.6,10-5,10-5Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 139.67,
    y1: 296.73,
    x2: 143.84,
    y2: 304.17,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 145.06,
    y1: 286.65,
    x2: 148.25,
    y2: 278.49,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "100.61 263.37 85.58 263.37 85.58 268.49 93.1 271.37 100.61 268.17 100.61 263.37",
    style: {
      fill: "#DC143C",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "130.68 263.37 115.65 263.37 115.65 268.49 123.17 271.37 130.68 268.17 130.68 263.37",
    style: {
      fill: "#DC143C",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg401);
export default __webpack_public_path__ + "static/media/401.88644a3a6b49d5c83675c063c0eb7ba5.svg";
export { ForwardRef as ReactComponent };